import React from "react";
import JsonData from "../JsonData/jsonData.json"
import { AiOutlineClose } from "react-icons/ai";
import { MdAccessTime } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";


const Modal24 = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (

    <div className="fixed top-0 bottom-0 left-0 right-0 z-40 w-full h-screen bg-black bg-opacity-60" >
      <div className="flex items-start justify-center h-screen p-4 overflow-hidden">

        <div className="mx-auto overflow-y-auto bg-[#FAFAFA] rounded-md xl:w-5/6 lg:w-5/6 customscroll5 h-[calc(100vh-2rem)]">
          <div className="px-8 py-5 text-[#212121] flex justify-between items-center">
            <h2 className="text-4xl font-semibold textcolor capitalize">Agenda of the event</h2>
            <AiOutlineClose className="w-6 h-6 cursor-pointer" onClick={onClose} />
          </div>
          <div className="px-4 lg:px-8 bg-white text-[#212121]">
            <ul className=" divide-y divide-gray-500">
              <li>
                <div className="grid py-4 lg:py-6 overflow-hidden md:grid-cols-5 rounded-xl xl:grid-cols-12">
                  <h3 className="mb-1 ml-8 text-2xl textcolor font-semibold md:col-start-3 md:col-span-4 md:ml-0 xl:col-start-4 xl:col-span-9">Taj Lands End, Mumbai</h3>
                  <div className="row-start-1 mb-1 md:col-start-1 xl:col-span-2 font-semibold flex items-center space-x-3">
                    <IoLocationOutline className="w-7 h-7 textcolor" />
                    <span className="whitespace-nowrap text-2xl">Location:</span>
                  </div>
                </div>
              </li>
              {JsonData.awrd24.map((awrd24, index) => (
                <li key={index}>
                  <div className="grid py-4 lg:py-6 overflow-hidden md:grid-cols-5 rounded-xl xl:grid-cols-12">
                    <h3 className="mb-1 ml-8 text-lg textcolor font-semibold md:col-start-3 md:col-span-4 md:ml-0 xl:col-start-4 xl:col-span-9">{awrd24.title}</h3>
                    <div className="row-start-1 mb-1 md:col-start-1 xl:col-span-2 font-semibold flex items-center space-x-3">
                      <MdAccessTime className="w-7 h-7 textcolor" />
                      <span className="whitespace-nowrap text-lg">{awrd24.time}</span>
                    </div>
                    <p className="ml-8 md:col-start-3 md:col-span-4 xl:col-start-4 xl:col-span-9 md:ml-0 font-medium pb-2">{awrd24.desc}</p>
                    <p className="ml-8 md:col-start-3 md:col-span-4 xl:col-start-4 xl:col-span-9 md:ml-0 font-semibold">{awrd24.by}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal24;